import { Navigate, Outlet, useParams } from 'react-router-dom'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { matterPaths } from '@/routing/paths'

/** Keep table pages and their requests unmounted until the runtime decision arrives. */
export default function TablesGuard() {
  const { matterId } = useParams()
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.TABLES)
  if (loading) return null
  if (!enabled) return <Navigate to={matterId ? matterPaths.overview(matterId) : '/dashboard/matters'} replace />
  return <Outlet />
}
